import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { IMyDateModel, INgxMyDpOptions, NgxMyDatePickerDirective } from "ngx-mydatepicker";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";


@Component({
    selector: 'date-picker',
    templateUrl: 'datepicker.component.html',
    moduleId: module.id.toString()
})
export class DatePickerComponent {
    @Input()
    public name: string;

    @Output()
    public onDateChange: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('dp') ngxdp: NgxMyDatePickerDirective;

    @Input()
    public myOptions: INgxMyDpOptions;

    model: any = { date: { year: 2018, month: 10, day: 9 } };

    constructor() {
    }

    public onDateChanged(event: IMyDateModel): void {
        this.onDateChange.emit(event);


    }

    public changeOption(opt : INgxMyDpOptions){
        this.ngxdp.options = opt;
    }

    public clearDate(): void {
        this.ngxdp.clearDate();
    }
}


// WEBPACK FOOTER //
// ./app/components/common/datepicker/datepicker.component.ts